import { useAuth } from "../../Auth/auth";
import Header from "./Header";
import SideNav from "./SideNav";

export default function Layout({ children }) {
  const { user } = useAuth();

  return user ? (
    <div className="flex min-h-screen">
      <SideNav />
      <div className="flex flex-col grow pb-10">
        <Header />
        {children}
      </div>
    </div>
  ) : (
    children
  );
}
